import {$app, ReactComponent} from "../app"
import React, {createRef} from "react"
import {Button, DatePicker, Form, Input, Space, Spin} from "antd"
import FloatLabel from "../components/inputs/FloatLabel"
import dayjs from "dayjs"
import {parsePhoneNumber} from "awesome-phonenumber"
import App from "../app/App"
import {Link} from "react-router-dom"

export default class AccountUpdatePage extends ReactComponent {
  formRef = createRef()

  state = {
    loading: false,
    loading_page: false,
    input_first_name_value: '',
    input_last_name_value: '',
    input_email_value: '',
    input_phone_value: '',
    input_birthdate_value: '',
    language_id: '',
  }

  async componentDidMount() {

    void this.updateState({loading_page: true})

    try {

      const customer = await $app.$api({
        action: 'carecloud_user_api'
      })

      const {personal_information = {}} = customer

      void this.updateState({
        input_first_name_value: personal_information.first_name || '',
        input_last_name_value: personal_information.last_name || '',
        input_email_value: personal_information.email || '',
        input_phone_value: this.phoneNumberFrom(personal_information.phone),
        input_birthdate_value: dayjs(personal_information.birthdate) || null,
        language_id: personal_information.language_id
      })

    } catch (error) {

      $app.$e('Nejste přihlášeni.')
      console.log(error)

    } finally {

      void this.updateState({loading_page: false})

    }

  }

  async handleFormSubmit() {

    void this.updateState({loading: true})

    try {
      const firstname = this.state.input_first_name_value
      const lastname = this.state.input_last_name_value
      const email = this.state.input_email_value
      const phone = this.state.input_phone_value.replace(/[\s+]/g, '')
      const birthdate = dayjs(this.state.input_birthdate_value).format('YYYY-MM-DD')
      const language_id = this.state.language_id

      await this.$api({
        action: 'carecloud_user_api',
        route: '',
        method: 'PUT',
        data: {
          customer: {
            personal_information: {
              language_id: language_id,
              first_name: firstname,
              last_name: lastname,
              email: email,
              phone: phone,
              birthdate: birthdate
            }
          }
        }
      })

      App.$toast('Údaje byly aktualizovány.')

      this.props.onSubmit()

    } catch (e) {

      $app.$e('Nepodařilo se změnit údaje.')
      console.log(e)

    } finally {

      void this.updateState({loading: false})

    }

  }

  phoneNumberFrom(phone) {
    try {
      return phone ? parsePhoneNumber(phone, {regionCode: 'CZ'}).number.international : ''
    } catch (e) {
      console.log(e)
      return ''
    }
  }

  render() {
    return (
      <>
        <section className="container centered full-height">

          <Spin spinning={this.state.loading_page} size="large">
            <h1 className="main-title">Úprava údajů</h1>

            <Form
              ref={this.formRef}
              className="pl-2 pr-2 mt-3"
              onFinish={() => {
                void this.handleFormSubmit()
              }}
            >

              <Form.Item
                rules={[{
                  required: true,
                  message: "Prosím vyplňte Jméno"
                }]}
              >
                <FloatLabel label="Jméno" value={this.state.input_first_name_value}>
                  <Input
                    size="large"
                    variant="underlined"
                    value={this.state.input_first_name_value}
                    onChange={(e) => {
                      void this.updateState({input_first_name_value: e.target.value})
                    }}
                  />
                </FloatLabel>
              </Form.Item>

              <Form.Item
                rules={[{
                  required: true,
                  message: "Prosím vyplňte Příjmení"
                }]}
              >
                <FloatLabel label="Příjmení" value={this.state.input_last_name_value}>
                  <Input
                    size="large"
                    variant="underlined"
                    value={this.state.input_last_name_value}
                    onChange={(e) => {
                      void this.updateState({input_last_name_value: e.target.value})
                    }}
                  />
                </FloatLabel>
              </Form.Item>

              <Form.Item
                rules={[{
                  required: true,
                  message: "Prosím vyplňte E-mail"
                }]}>
                <FloatLabel label="E-mailová adresa" value={this.state.input_email_value}>
                  <Input
                    size="large"
                    variant="underlined"
                    disabled
                    value={this.state.input_email_value}
                    onChange={(e) => {
                      void this.updateState({input_email_value: e.target.value})
                    }}
                  />
                </FloatLabel>
              </Form.Item>

              <Form.Item
                rules={[{
                  required: true,
                  message: "Prosím vyplňte Telefonní číslo"
                }]}>
                <FloatLabel label="Telefonní číslo" value={this.state.input_phone_value}>
                  <Input
                    size="large"
                    variant="underlined"
                    value={this.state.input_phone_value}
                    onChange={(e) => {
                      void this.updateState({input_phone_value: e.target.value})
                    }}
                  />
                </FloatLabel>
              </Form.Item>

              <Form.Item
                rules={[{
                  required: true, message: "Vyplňte prosím datum narození."
                }]}>
                <FloatLabel label="Datum narození" value={"true"}>
                  <DatePicker
                    size="large"
                    placement="topLeft"
                    format={{
                      format: "DD.MM.YYYY"
                    }}
                    variant="underlined"
                    value={this.state.input_birthdate_value}
                    onChange={(e) => {
                      void this.updateState({input_birthdate_value: e})
                    }}
                  />
                </FloatLabel>

              </Form.Item>

              <Space style={{marginTop: 20}} size={[18, 20]} direction="vertical" className="container full ta-center">
                <Button
                  htmlType="submit"
                  type="primary"
                  block
                  icon={<Spin spinning={this.state.loading}/>}
                  className="btn btn-primary _secondary _primary-text">
                  Uložit</Button>
              </Space>

              <Space style={{marginTop: '1em'}} size={[18, 20]} direction="vertical" className="container full ta-center mb-3">

                <Link to="/change-password">
                  <Button
                    type="text"
                    style={{height: '2.8em'}}
                  >Změna hesla</Button>
                </Link>

              </Space>

            </Form>

          </Spin>

        </section>
      </>

    )
  }
}